import { AudioContextManager, SoundLoader } from "audio_utils";
import { AppSettings } from "../settings/AppSettings";

export class SfxPlayer {
	public static _sfx:Map<string, AudioBuffer>;
	
	public static async loadSounds():Promise<void> {
		let context = AudioContextManager.context;
		let r = AppSettings.resourcesPath;
		SfxPlayer._sfx = new Map<string, AudioBuffer>();
		let clap1 = await SoundLoader.getAudioBufferFromUrl(
			`${r}sounds/sfx/reactionClap.mp3`, context);
		SfxPlayer._sfx.set("clap1", clap1);
		let clap2 = await SoundLoader.getAudioBufferFromUrl(
			`${r}sounds/sfx/clapMore.mp3`, context);
		SfxPlayer._sfx.set("clap2", clap2);
		let clap3 = await SoundLoader.getAudioBufferFromUrl(
			`${r}sounds/sfx/reaction_Yahoo.mp3`, context);
		SfxPlayer._sfx.set("clap3", clap3);
	}
	
	public static playSound(soundId:string):void {
		let buffer = SfxPlayer._sfx.get(soundId);
		
		let ctx = AudioContextManager.context;
		let bsn = ctx.createBufferSource();
		bsn.buffer = buffer;
		let gain = ctx.createGain();
		bsn.connect(gain);
		gain.connect(ctx.destination);
		bsn.start();
	}
}